import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { IAnalyticsCommonAPI } from '../types/api';
import { BoardDefaults, GetBoardsRequest } from '@common/types/dictionaries/analytics';
import { AnalyticsActions } from '../types/actions';

export const analyticsGetBoardsRoutineFactory = (
  api: IAnalyticsCommonAPI,
  actions: AnalyticsActions
): (() => Generator<ForkEffect<never>, void>) => {
  function* worker(action: PayloadAction<GetBoardsRequest & BoardDefaults>) {
    const { payload } = action;
    const { request, success, failure, fulfill } = actions.analyticsCommonGetBoardsRoutine;
    try {
      yield put(request(payload));
      const { data } = yield call(api.boardIndex, payload);
      yield put(success({ data: data.data, defaults: { ...payload.defaults } }));
    } catch (error) {
      console.error(error);
      yield put(failure(error));
    } finally {
      yield put(fulfill());
    }
  }

  function* watcher() {
    yield takeLatest(actions.analyticsCommonGetBoardsRoutine.TRIGGER, worker);
  }

  return watcher;
};
